/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('SearchCtrl', function($scope, $routeParams, identity, Search, Activity) {
    $scope.me   = identity;
    $scope.from = 0;
    $scope.size = 10;

    $scope.load = from => Search
    .get({
        query: $routeParams.query,
        type:  'user',
        from:  ($scope.from = from),
        size:  $scope.size}).$promise
    .then(function(search_result) {
        $scope.search_result = search_result;
        $scope.pages         = Math.ceil(search_result.total / $scope.size);
        $scope.pages_list    = __range__(1, $scope.pages, true);

        $scope.search_result.hits.map(function(result) {
            if ('user' === result._type) { return; }
            return Activity
            .profs({
                activity_id:   result._source.activity_id,
                activity_type: result._source.type,
                session_id:    result._source.session_id}).$promise
            .then(function(profs_list) {
                const isADM         = ($scope.me != null) && (-1 !== $scope.me.groups.indexOf('adm'));
                const profs_logins  = profs_list.map(prof => prof.login);
                const profOnThisUv  = -1 !== profs_logins.indexOf($scope.me.login);
                return result.isProf = (isADM || profOnThisUv);
            });
        });

        return $scope.currentPage = 0 === $scope.from ? 1 : Math.round($scope.from / $scope.size) + 1;
    });

    return $scope.load($scope.from, $scope.size);
});

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}